import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction, serviceCall } from '../../serviceCall'

const shareServiceRequest = (data, callback, errorCallBack,params) => {
  
  return async (dispatch) => {
 
    formDataCommonFunction(data,apiConstants.TICKET.SHARE_SERVICE_REQUEST)
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}

export default shareServiceRequest;
